export const clockTypesOptionsData = [
    {
        content: "Numérique",
        value: "numeric",
    },
    {
        content: "Analogique",
        value: "analogic",
    },
];
export const clockFormatsOptionsData = [
    {
        content: "12h",
        value: "12h",
    },
    {
        content: "24h",
        value: "24h",
    },
];
// @ts-ignore
export const clockTimezonesOptionsData = Intl.supportedValuesOf("timeZone").map((timezone) => ({
    label: timezone,
    value: timezone,
}));
